// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { InputSwitch } from 'Components/frameworks/form-inputs/input-switch/InputSwitch.jsx';

type Props = {
  choices: Array<{
    label: Node,
    value: string,
    isSelected?: boolean,
    icon?: IconName,
  }>,
  className?: string,
  listClassName?: string,
  name: string,
  onChange: (name: string, checked: boolean, value: string | boolean) => void,
  showToggleAll?: boolean,
  title: string,
  toggleAllValue?: string,
  dataTestId?: string,
};

export function ChoiceList(props: Props) {
  const {
    choices = [],
    className,
    listClassName,
    name,
    onChange,
    showToggleAll,
    title,
    toggleAllValue,
    dataTestId,
  } = props;

  const onToggle = (_: string, isSelected: boolean, value: string | boolean) => {
    props.onChange(props.name, isSelected, value);
  };

  return (
    <fieldset className={classnames('p-0 m-0 border-0', className)} data-testid={dataTestId}>
      {title && (
        <legend
          className={classnames('p-none mb-1', {
            'text-xl text-blue font-bold': !showToggleAll,
          })}
        >
          {showToggleAll ? (
            <InputSwitch
              label={title}
              isChecked={choices.every(choice => choice.isSelected)}
              onChange={onChange}
              name={name}
              size="large"
              value={toggleAllValue}
            />
          ) : (
            title
          )}
        </legend>
      )}
      {choices.length > 0 && (
        <ul className={classnames('list-none p-0', listClassName)}>
          {choices.map(choice => (
            <li className="flex items-center mb-2" key={choice.value}>
              {choice.icon && (
                <Icon className="mr-3" color={COLORS.BLUE} name={choice.icon} width="1.5rem" />
              )}
              <InputSwitch
                name={`${name}[]`}
                label={choice.label}
                value={choice.value}
                isChecked={!!choice.isSelected}
                onChange={onToggle}
              />
            </li>
          ))}
        </ul>
      )}
    </fieldset>
  );
}
